import { accountMergingActions } from './actionTypes';
import { AccountMergingState } from 'User/types/accountMerging';
import { Action } from 'shared/store/types';
import initialState from './constants/initialState';

const defaultState: AccountMergingState = initialState;

const accountMerging = (state = defaultState, action: Action): AccountMergingState => {
  const { type, payload } = action;
  const { steps } = state;
  const positionOfInterest = payload?.positionOfInterest;
  let stepsOfInterest = steps;
  if (typeof positionOfInterest === 'number' && positionOfInterest >= 0) {
    stepsOfInterest = steps.slice(0, positionOfInterest + 1);
  }
  switch (type) {
    case accountMergingActions.PUSH:
      return {
        ...state,
        mobileNumber: payload.mobileNumber,
        changeMob: payload.changeMob || state.changeMob,
        steps: [...stepsOfInterest, payload.stepData],
      };

    case accountMergingActions.REPLACE: {
      const stepsToConsiderWhileReplace = stepsOfInterest.slice(0, -1);
      const currentStepData = stepsOfInterest[positionOfInterest];
      return {
        ...state,
        mobileNumber: payload.mobileNumber,
        emailId: payload.emailId,
        changeMob: payload.changeMob || state.changeMob,
        steps: [...stepsToConsiderWhileReplace, { ...currentStepData, ...payload.stepData }],
      };
    }
    case accountMergingActions.CHECK_EXISTENCE:
      return {
        ...state,
        isExists: payload.isExists,
        linkedEmail: payload.linkedEmail,
        mobileNumber: payload.mobileNumber,
        emailId: payload.emailId,
      };

    case accountMergingActions.SET_PREVIOUS_PAGE_NAME:
      return {
        ...state,
        previousPageName: payload.previousPageName,
        root: payload.root,
      };

    default:
      return state;
  }
};

export default accountMerging;
